import { useEffect, useRef } from 'react'
import { useReactToPrint } from 'react-to-print';
import './print.css'
import constant from '../../../constants/constant';
import { StandardBarcode } from './barcodeFormates';
import { OrpBarcodeFormat } from './barcodeFormates/orpFormat';
const Index = ({ downloadBarcode,barcodeFormat,showStoreName }: any) => {
    const targetRef = useRef(null);

    const handlePrint = useReactToPrint({
        content: () => targetRef.current,
        documentTitle: "barcodes" + Math.floor(100000 + Math.random() * 900000).toString()
    }as any);

    const handleRenderBarcodeFormat = (index: number, item: any) => {
        const storeRegion = Number(item?.store_region || constant.STORE_REGION.INDIA);
        const Component =
          barcodeFormat === constant.BARCODE_FORMAT.SRP_ORP
            ? OrpBarcodeFormat
            : StandardBarcode;
      
        return (
          <Component
            key={index}
            item={item}
            index={index}
            showStoreName={showStoreName}
          />
        );
      };
      

    useEffect(() => {
        if (downloadBarcode && downloadBarcode.length > 0) {
            // generatePDF(targetRef, options)
            handlePrint()
        }
    }, [downloadBarcode])

    return (
        <div className="container barcode-container ps-2 " ref={targetRef}>
        {downloadBarcode?.map((item: any, index: number) => {
            return (
                handleRenderBarcodeFormat(index,item)
            );
        })}
    </div>
    )
}

export default Index